import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarModelModalService {

  private selectedCarModelSubject = new BehaviorSubject<any>(null);
  public selectedCarModel$ = this.selectedCarModelSubject.asObservable();

  constructor() { }

  setSelectedCarModel(carModel: any): void {
    this.selectedCarModelSubject.next(carModel);
  }

  getSelectedCarModel(): any | null {
    return this.selectedCarModelSubject.value;
  }

  clearSelectedCarModel(): void {
    this.selectedCarModelSubject.next(null);
  }
}
